<div class="row container-style mb-1" [hidden]="!isFormView">
  <div class="col-12 col-md-12 py-1">
    <form [formGroup]="formRepair">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Insumo'" [list]="listSupply"
            [required]="true"></app-custom-autocomplete>
        </div>
        <div class="col-lg-3 col-md-2 col-sm-6 col-12">
          <app-custom-textarea formControlName="detailText" [labelText]="'Detalle'" [rows]="1"
            [autoResize]="false"></app-custom-textarea>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"
            (onChangeNumber)="calculateTotalValue()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unit.'"
            (onChangeNumber)="calculateTotalValue()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [value]="vrTotal" [labelText]="'Vr.Total'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-5 col-sm-6 col-12 d-flex mt-2">
          <div class="d-flex align-items-end justify-content-end gap-1 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="row container-style">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2 py-1">
    <app-custom-button *ngIf="maintenanceOrderClassId === scheduledClass" [title]="'Agregar Insumos Plan'"
      [label]="'Agregar Insumos Plan'" [icon]="'pi pi-sync'" [width]="'11rem'" [severity]="'success'"
      (onClick)="addSupplies()"
      [disabled]="!permissionUpdatable || maintenanceOrderStateId === maintenanceOrderCloseFinal || this.swCostRepairState || this.swBlock"></app-custom-button>
    <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'6rem'" [severity]="'success'"
      [variant]="undefined" (onClick)="newRepair(true)"
      [disabled]="!permissionUpdatable || maintenanceOrderStateId === maintenanceOrderCloseFinal || this.swCostRepairState || this.swBlock"></app-custom-button>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
    <app-custom-table [headers]="header" [data]="repairData" [actions]="tableActions" [showExport]="true"
      [showCheckbox]="permissionUpdatable && maintenanceOrderStateId !== maintenanceOrderCloseFinal && this.swCostRepairState == false && this.swBlock == false"
      [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
      (onPageChange)="onPageChange($event)" (onRecoverData)="getAllRepairsModalWithPagination()"
      (onAction)="onAction($event)" (onExport)="onExport()">
    </app-custom-table>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-2">
    <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
      (onClick)="close()"></app-custom-button>
  </div>
</div>